import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

// Confetti examples here: https://www.kirilv.com/canvas-confetti/
export default class extends Controller {
  connect() {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });
  }
}
